import React, {useState} from "react";
import Bilde from "./Bilde";
import utdannelseLogo from "../img/opdraetterlogo.png";
import masterclassLogo from "../img/masterclass_100.png";
// import utdannelseLogo from "../img/dkk-logo-small.png";
import ElementHelp from "./ElementHelp";
import VismerKnappen from '../components/VismerKnappen';
import Kull from "./Kull";
import Uploadable from './Uploadable';
import icons from "../helpers/icons";
import {postForm} from "../api";


const KullOppdretter = (props) => {
    const {hund, kullOppdretter, profilBilde, personId, reloadBilde} = props;
    const [showKullListe, setShowKullListe] = useState(false);
    if (kullOppdretter === null || kullOppdretter.hovedOppdretter === null) {
        return (
            <div className="dogweb-box">
                <h4>Opdrætter</h4>
                <div className="breeder-card"></div>
            </div>
        );
    }

    function slettOppdretterBilde() {
        const formdata = new FormData();
        postForm("slettOppdretterProfilBilde", formdata)
            .then((data) => {
                reloadBilde();
            })
            .catch((err) => {
                console.log(err);
            });
    }



    const showUploadIcon = () => {
        if (hund.ikkeVisOppdretterProfilData === false &&
            profilBilde === null &&
            personId !== null &&
            kullOppdretter !== null &&
            kullOppdretter.hovedOppdretterId === personId
        ){
            return true;
        }
        return false;

    };

    const showDeleteIcon = () => {
        if (profilBilde !== null &&
            personId !== null &&
            kullOppdretter !== null &&
            kullOppdretter.hovedOppdretterId === personId
        ){
            return true;
        }
        return false;
    };


    const url = "http://" + kullOppdretter.webUrl;
    const oppdretterStyleClass = kullOppdretter !== null &&
                                kullOppdretter.hovedOppdretter !== null &&
                                profilBilde !== null ? "dogweb-card profil" : "dogweb-card";

    return (
        <div className="dogweb-box">
            <div className="dogweb-card-header">
                <div className="card-title">Opdrætter </div>
                <div className="name-active-dog"> {hund.navn}</div>
                <ElementHelp slug={'opdretter'}/>
            </div>
            <div className={oppdretterStyleClass}>

                <div className="profilbilde">
                    { showUploadIcon() &&  <Uploadable action="uploadOppdretterProfilBilde" hundId={hund.hundId} reloadBilde={reloadBilde} /> }
                    { showDeleteIcon() &&  <button onClick={slettOppdretterBilde} className="slet-knapp"><img alt="" className="icon slet" src={icons.slet} title="Slet billede" /></button> }
                    {
                        profilBilde !== null &&
                        <Bilde url={profilBilde.url}
                               className="dog-image"
                               heroimage={false}/>
                    }
                </div>

                <div className="breeder-card profildata">
                    {
                        kullOppdretter.kennelmerke !== null &&
                            <h3>{kullOppdretter.kennelmerke}</h3>
                    }
                    <p><label>Navn:</label> {kullOppdretter.oppdretterbeskrivelse}</p>
                    {
                        kullOppdretter.hovedOppdretter.epost &&
                            <p><label>E-mail:</label> {kullOppdretter.hovedOppdretter.epost}</p>
                    }
                    {
                        kullOppdretter.hovedOppdretter.telefon &&
                        <p><label>Telefon:</label> {kullOppdretter.hovedOppdretter.telefon} </p>
                    }

                    {
                        kullOppdretter.webUrl !== null &&
                            <p><label>Web:</label> <a href={url} target="_blank" rel="noopener noreferrer">{kullOppdretter.webUrl}</a></p>
                    }

                    {
                        kullOppdretter.hovedOppdretter.postnummer !== null &&
                        <p><label>Postnr/sted:</label> {kullOppdretter.hovedOppdretter.postnummer} {kullOppdretter.hovedOppdretter.poststed}</p>
                    }
                    {
                        kullOppdretter.hovedOppdretter.land !== null &&
                            <p><label>Land:</label> {kullOppdretter.hovedOppdretter.land}</p>
                    }
                    {
                        kullOppdretter.utdannelse &&
                        <img src={utdannelseLogo} alt="" className="utdannelseLogo"   />
                    }
                    {
                        kullOppdretter.masterclass &&
                        <img src={masterclassLogo} alt="" className="utdannelseLogo"   />
                    }


                </div>
            </div>
            <div className="dogweb-card">
                {
                    kullOppdretter !== null &&
                    <>
                        <button className="more-results link-button"
                                onClick={() => setShowKullListe(!showKullListe)}>
                            Vis opdrætterens kuld
                        </button>
                        {
                            showKullListe &&
                            <KullListe kullListe={kullOppdretter.kullListe} />
                        }
                    </>
                }
            </div>
        </div>
    );

};

const KullListe = (props) => {
    const [kullVises, setKullVises] = useState(5);

    const liste = props.kullListe || [];
    const rows = liste.map((kull) => (
        <Kull showRase={true} key={kull.kullId} kull={kull} />
    )).splice(0, kullVises);

    return (
        <div >

            {rows}
            {liste.length === 0 &&
            <div>&nbsp;</div>
            }

            <VismerKnappen
                total={liste.length}
                maxStep="5"
                renderedAmount={kullVises}
                incrementer={setKullVises}
            />
        </div>
    );

};


export default KullOppdretter;
